import { API_BASE_URL } from '../utils/api';

const request = async (path, options = {}) => {
  const headers = { ...(options.headers || {}) };
  const token = localStorage.getItem('storeToken');
  if (token) headers.Authorization = `Bearer ${token}`;

  let body = options.body;
  if (body && !(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers, body });
  const result = await response.json().catch(() => null);
  if (!response.ok || result?.status !== 'SUCCESS') {
    throw new Error(result?.message || 'Store employee request failed.');
  }
  return { status: result.status, message: result.message, data: result.data };
};

export const listStoreActiveEmployees = ({ page = 1, limit = 20, search = '' } = {}) => {
  const params = new URLSearchParams();
  params.set('page', page);
  params.set('limit', limit);
  if (search && search.trim()) params.set('search', search.trim());
  return request(`/api/store/employees?${params.toString()}`);
};
